import { createSelector } from '@reduxjs/toolkit';

const getSlicer = (state, props) => state.slicerStore.slicers[props.routeID];

const selectSlicers = () =>
  createSelector([getSlicer], slicers => slicers || {});

// eslint-disable-next-line import/prefer-default-export
export { selectSlicers };
